/**
 * @description 用户分布图 userDistribution
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const userDistributionBiz = new Logic()

userDistributionBiz.getUserData = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userDistribution.getUserData,
    data: data
  })
}

export default userDistributionBiz
